"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var FilterStack =
/*#__PURE__*/
function () {
  function FilterStack(filters) {
    _classCallCheck(this, FilterStack);

    this.filters = filters;
  }

  _createClass(FilterStack, [{
    key: "sendMetadata",
    value: function sendMetadata(metadata) {
      return lodash_1.flow(lodash_1.map(this.filters, function (filter) {
        return filter.sendMetadata.bind(filter);
      }))(metadata);
    }
  }, {
    key: "receiveMetadata",
    value: function receiveMetadata(metadata) {
      return lodash_1.flowRight(lodash_1.map(this.filters, function (filter) {
        return filter.receiveMetadata.bind(filter);
      }))(metadata);
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      return lodash_1.flow(lodash_1.map(this.filters, function (filter) {
        return filter.sendMessage.bind(filter);
      }))(message);
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(message) {
      return lodash_1.flowRight(lodash_1.map(this.filters, function (filter) {
        return filter.receiveMessage.bind(filter);
      }))(message);
    }
  }, {
    key: "receiveTrailers",
    value: function receiveTrailers(status) {
      return lodash_1.flowRight(lodash_1.map(this.filters, function (filter) {
        return filter.receiveTrailers.bind(filter);
      }))(status);
    }
  }]);

  return FilterStack;
}();

exports.FilterStack = FilterStack;

var FilterStackFactory =
/*#__PURE__*/
function () {
  function FilterStackFactory(factories) {
    _classCallCheck(this, FilterStackFactory);

    this.factories = factories;
  }

  _createClass(FilterStackFactory, [{
    key: "createFilter",
    value: function createFilter(callStream) {
      return new FilterStack(lodash_1.map(this.factories, function (factory) {
        return factory.createFilter(callStream);
      }));
    }
  }]);

  return FilterStackFactory;
}();

exports.FilterStackFactory = FilterStackFactory;